import type { DupeKind } from '@onefootprint/request-types/dashboard';
import useEntityDuplicateData from './use-entity-duplicate-data';
import useEntityId from './use-entity-id';
const useCurrentEntityDuplicateData = (timestamp, enabled, kinds) => {
  const id = useEntityId();
  return useEntityDuplicateData(id, timestamp, enabled, kinds);
};
export default useCurrentEntityDuplicateData;